import { useEffect, useState, useCallback } from "react";

const KEY = "cem_theme";

export const readTheme = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : "dark";
  } catch {
    return "dark";
  }
};

export const applyTheme = (t) => {
  document.documentElement.classList.toggle("dark", t !== "light");
};

/* Shared theme hook for public (non-dashboard) pages. */
export function usePublicTheme() {
  const [theme, setTheme] = useState(readTheme);
  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(KEY, JSON.stringify(theme));
  }, [theme]);
  const toggle = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);
  return { theme, toggle };
}
